module.exports = __webpack_public_path__ + "img/qq.11dce9d5.svg";